"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    clientDowngradeUtil: ()=>clientDowngradeUtil,
    clientDowngrades: ()=>clientDowngrades
});
const comon_js_namespaceObject = require("../../utils/comon.js");
const index_js_namespaceObject = require("../common/index.js");
const clientDowngrades = (0, index_js_namespaceObject.getDowngradeValues)(comon_js_namespaceObject.hasWindow ? window.location.search : void 0);
const downgradeCache = {
    components: void 0,
    materials: void 0
};
const clientDowngradeUtil = {
    get forceCDNRegion () {
        return (0, index_js_namespaceObject.getForceCDNDowngradeRegion)(clientDowngrades);
    },
    get isForceCDN () {
        return (0, index_js_namespaceObject.getIsForceCDNDowngrade)(clientDowngrades);
    },
    get isDisableCDN () {
        return clientDowngrades.includes(index_js_namespaceObject.manualDowngradeKeys.DISABLE_CDN);
    },
    get isDisablePwaCache () {
        return clientDowngrades.includes(index_js_namespaceObject.manualDowngradeKeys.DISABLE_PWA_CACHE);
    },
    get isProductEntryNoCDN () {
        return clientDowngrades.includes(index_js_namespaceObject.manualDowngradeKeys.PRODUCT_ENTRY_NO_CDN);
    },
    get isProductConfigUseCDN () {
        return clientDowngrades.includes(index_js_namespaceObject.manualDowngradeKeys.PRODUCT_CONFIG_USE_CDN);
    },
    get isJwtDisableSSO () {
        return clientDowngrades.includes(index_js_namespaceObject.manualDowngradeKeys.JWT_NO_SSO);
    },
    get isJwtUseBackup () {
        return clientDowngrades.includes(index_js_namespaceObject.manualDowngradeKeys.JWT_USE_BACKUP);
    },
    get isDisableJwt () {
        return clientDowngrades.includes(index_js_namespaceObject.manualDowngradeKeys.DISABLE_JWT);
    },
    get isDisableAllComponents () {
        return clientDowngrades.includes(index_js_namespaceObject.manualDowngradeKeys.DISABLE_COMPONENTS);
    },
    get downgradedComponents () {
        if (!Array.isArray(downgradeCache.components)) downgradeCache.components = clientDowngrades.reduce((result, item)=>{
            if (item.startsWith(index_js_namespaceObject.manualDowngradeKeys.DISABLE_COMPONENT_PREFIX)) result.push(item.slice(index_js_namespaceObject.manualDowngradeKeys.DISABLE_COMPONENT_PREFIX.length));
            return result;
        }, []);
        return downgradeCache.components;
    },
    get isDisableAllMaterials () {
        return clientDowngrades.includes(index_js_namespaceObject.manualDowngradeKeys.DISABLE_MATERIALS);
    },
    get downgradedMaterials () {
        if (!Array.isArray(downgradeCache.materials)) downgradeCache.materials = clientDowngrades.reduce((result, item)=>{
            if (item.startsWith(index_js_namespaceObject.manualDowngradeKeys.DISABLE_MATERIAL_PREFIX)) result.push(item.slice(index_js_namespaceObject.manualDowngradeKeys.DISABLE_MATERIAL_PREFIX.length));
            return result;
        }, []);
        return downgradeCache.materials;
    }
};
exports.clientDowngradeUtil = __webpack_exports__.clientDowngradeUtil;
exports.clientDowngrades = __webpack_exports__.clientDowngrades;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "clientDowngradeUtil",
    "clientDowngrades"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
